import { search_asp, trimFieldString } from "../util.js";

export function translateRemoveTextPartial(tech, args, line, parsed, source, mapping, processed, config) {
  // do(remove_text_partial, L, T, min_max).
  // do(remove_text_partial, L, T, min_max_zero).
  // do(remove_text_partial, L, T, every_other).
  let rules = [];
  let text_map = mapping[args[1]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];
  let transform_type = args[2];
  let datatype = source.datatype;
  if (layer && text) {
    let rule = {
      category: "recommender",
      description: `Remove some of ${text.type} text for ${text.field} (${transform_type})`,
      specifier: {
        role: { "on-mark": "mark.label", "on-axis": "axis.label", "legend": "legend" }[text.type],
        field: text.field
      },
      action: "modify",
      option: {}
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: text_map?.layer };
    }
    if (transform_type === "min_max") {
      if (text.values) {
        rule.option.values = [Math.min(...text.values), Math.max(...text.values)]
      } else if (datatype) {
        rules.option.values = [datatype[text.field].min, datatype[text.field].max];
      } else {
        return [];
      }
    } else if (transform_type === "min_max_zero") {
      if (text.values) {
        rule.option.values = [Math.min(...text.values), 0, Math.max(...text.values)]
      } else if (datatype) {
        rules.option.values = [datatype[text.field].min, 0, datatype[text.field].max];
      } else {
        return [];
      }
    } else if (transform_type === "every_other") {
      if (text.values) {
        rule.option.values = text.values.filter((_, i) => i % 2 == 0);
      } else {
        return [];
      }
    } else {
      return [];
    }
    rules.push(rule);
  }
  return rules;
}

export function translateAddTextPartial(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(add_text_partial,L,T,every_other)
  let text_map = mapping[args[1]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];
  let transform_type = args[2];
  let datatype = source.datatype;
  if (layer && text) {
    let rule = {
      category: "recommender",
      description: `Add some of ${text.type} text for ${text.field} (${transform_type})`,
      specifier: {
        role: { "on-mark": "mark.label", "on-axis": "axis.label", "legend": "legend" }[text.type],
        field: text.field
      },
      action: "modify",
      option: {}
    }
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: text_map?.layer };
    }
    if (transform_type === "every_other" && text.values) {
      let values = text.values;
      let new_values = [];
      for (let i of values) {
        if (i < values.length - 1) {
          new_values.push(values[i]);
          new_values.push((values[i] + values[i + 1]) / 2)
        }
      }
      rule.option.values = new_values;
    } else {
      return [];
    }

    rules.push(rule);
  }
  return rules;
}

export function translateAddAxisLabel(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  // do(add_axis_label,L,F)
  let layer = source.layer?.[mapping[args[0]]?.layer];
  let field = trimFieldString(args[1]);
  if (layer) {
    let rule = {
      category: "recommender",
      description: `Add axis label for ${field}`,
      specifier: {
        role: "axis",
        field: field
      },
      action: "add",
      option: {
        role: "label"
      }
    }
    if (layer.name) rule.specifier.layer = { id: layer.name };
    else rule.specifier.layer = { index: mapping[args[0]]?.layer };
    rules.push(rule);
  }
  return rules;
}

export function translateParallelizeText(tech, args, line, parsed, source, mapping, processed, config) {
  // do(parallelize_text, T).
  let rules = [];
  let text_map = mapping[args[0]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];
  let datatype = source.datatype;
  if (layer && text) {
    let rule = {
      category: "recommender",
      description: `Parallelize ${text.type} text for ${text.field}`,
      specifier: {
        role: { "on-mark": "mark.label", "on-axis": "axis.label", "legend": "legend" }[text.type],
        field: text.field
      },
      action: "modify",
      option: {
        serial: false
      }
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: parseInt(text_map?.layer) };
    }
    rules.push(rule);
  }
  return rules;
}

export function translateRemoveTickValues(tech, args, line, parsed, source, mapping, processed, config) {
  // do(remove_tick_values,L,T)
  let rules = [];
  let text_map = mapping[args[1]];
  let layer = source.layer?.[text_map?.layer];
  let text = layer?.text[text_map?.text];
  if (layer && text) {
    let rule = {
      category: "recommender",
      description: `Remove some of ${text.type} ticks for ${text.field}`,
      specifier: {
        role: "axis.tick",
        field: text.field
      },
      action: "modify",
      option: {
        tickValues: null
      }
    };
    if (layer.name) {
      rule.specifier.layer = { id: layer.name };
    } else {
      rule.specifier.layer = { index: text_map?.layer };
    }
    rules.push(rule);
  }
  return rules;
}

